import { BidiMode } from "@models/bidiMode";
import { Blackbox } from "@models/blackbox";
import { ChargingStationDto } from "./chargingStationDto";

export class BidiConfigurationDto {
  id: string;
  gatewayId: number;
  gateway: Blackbox | null;
  bidiModeId: string;
  bidiMode: BidiMode;
  targetPowerInWatt: number;
  minSoc: number;
  maxSoc: number
  chargingStationDtos: ChargingStationDto[] | null;

  constructor(data?: Partial<BidiConfigurationDto>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}